// extracted by mini-css-extract-plugin
module.exports = {"IntroSmall":"IntroSmall_IntroSmall__2FXR7","Main":"IntroSmall_Main__1elU6","Description":"IntroSmall_Description__1wQ-4"};